import React, { FC } from 'react';
import { Popper, PopperProps } from '@material-ui/core';

const CustomPopper: FC<PopperProps> = (props) => {
  return (
    <Popper
      {...props}
      children={props.children}
      modifiers={{
        offset: {
          enabled: true,
          offset: '0, 10',
        },
      }}
    />
  );
};

export default CustomPopper;
